export default __webpack_public_path__ + "static/media/1.4db037c6.jpg";